import TheViewHomeHero from '@helpers/TheViewHomeHero.class';

const element = document.querySelector<HTMLElement>('.kf-o-the-view-home-hero');

if (element) {
  const instance = new TheViewHomeHero(element);

  instance.init();
}

export {};
